import { render, staticRenderFns } from "./ItemBlock.vue?vue&type=template&id=a21ac1b0&scoped=true&"
import script from "./ItemBlock.vue?vue&type=script&lang=js&"
export * from "./ItemBlock.vue?vue&type=script&lang=js&"
import style0 from "./ItemBlock.vue?vue&type=style&index=0&id=a21ac1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21ac1b0",
  null
  
)

export default component.exports